import { AvatarModule } from 'primeng/avatar';
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SessionService } from '@/common/auth/auth-session.service';
import { UserSessionInterface } from '@/common/auth/auth.interface';
import { MenuModule } from 'primeng/menu';
import { RippleModule } from 'primeng/ripple';
import {RouterLink, RouterLinkActive} from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { ROLES } from '@/constants/roles.constants';
import { DevToolsService } from '@/pages/dev-tools/dev-tools.service';

@Component({
    selector: 'app-sidebar',
	imports: [
		AvatarModule,
		CommonModule,
		MenuModule,
		RippleModule,
		RouterLink,
		ButtonModule,
		TranslateModule,
		RouterLinkActive,
	],
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
		host: {
			class:
				'flex flex-col h-full',
		},
})
export class SidebarComponent implements OnInit {
	user: UserSessionInterface | null = null;
	roles = ROLES;
  isAdmin = this.sessionService.hasRole('admin') || this.sessionService.hasRole('superadmin');
	menuItems = [
		// Only for those the API lets list them: anyone else would get a 403 (hasPermission is true for superadmins).
		...(this.sessionService.hasPermission('view_project')
			? [{
				key: 'generic.menuItems.projects',
				icon: 'pi pi-folder-open',
				route: '/projects',
			}]
			: []),
		...(this.sessionService.hasPermission('view_user')
			? [{
				key: 'generic.menuItems.users',
				icon: 'pi pi-users',
				route: '/users',
			}]
			: []),
		...(this.sessionService.hasPermission('view_person_mapping')
			? [{
				key: 'generic.menuItems.personMappings',
				icon: 'pi pi-link',
				route: '/person-mappings',
			}]
			: []),
		// The settings route lets superadmins and admins in (RoleGuard): admins for the alert channel (task 9.1)
		...(this.sessionService.isSuperAdmin() || this.sessionService.hasRole(ROLES.ADMIN)
			? [{
				key: 'generic.menuItems.settings',
				icon: 'pi pi-cog',
				route: '/settings',
			}]
			: []),
	];
	devToolsMenuItems = [
		{
			key: 'generic.menuItems.telescope',
			icon: 'pi pi-search',
			action: () => this.devToolsService.openTool('telescope'),
		},
		{
			key: 'generic.menuItems.horizon',
			icon: 'pi pi-server',
			action: () => this.devToolsService.openTool('horizon'),
		},
	];

	constructor(
		private readonly sessionService: SessionService,
		private readonly devToolsService: DevToolsService
	) {}

	ngOnInit(): void {
		this.sessionService.userSessionState$.subscribe(user => (this.user = user));
	}
}
